module.exports = __webpack_public_path__ + "static/media/Card_Back.05dfdaf5.svg";